<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized" class="space-1">
  <a [routerLink]="['../../']">< Conferences</a>
  <h4>{{ conference.name }} - Event Summaries</h4>

  <div class="row">
    <div class="col-xl-3 col-lg-4 col-md-5">
      <div class="panel panel-success">
        <div class="panel-heading">
          <h5 class="ceu-title ng-star-inserted">Valid Events</h5>
        </div>
        <div class="panel-body ceu-info-number">{{ correctCount }}</div>
      </div>
    </div>
    <div class="col-xl-3 col-lg-4 col-md-5 ng-star-inserted">
      <div class="panel panel-danger">
        <div class="panel-heading">
          <h5 class="ceu-title">Incomplete Events</h5>
        </div>
        <div class="panel-body ceu-info-number">{{ incorrectCount }}</div>
      </div>
    </div>
  </div>
  <div class="row pl-3 pr-3">
    <div class="col-xl-12 col-lg-12 col-md-12 alert alert-warning">
      <strong>NOTE:</strong> All events must have BOTH
      <strong>"Feedback"</strong> and
      <strong>"Critera Met"</strong> to get CEUs. Please review the events below and resolve any issues by clicking "Fix".
    </div>
  </div>

  <div class="card mb-2" *ngFor="let evnt of events">
    <div *ngIf="!evnt.ceuParticipationDate" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgb(85, 85, 85); opacity: 0.8; z-index: 8">
      <div class="text-white d-flex h-100">
        <h4 class="my-auto mx-auto">No Participation</h4>
      </div>
    </div>
    <div class="card-body p-4">
      <div class="row">
        <div class="col-md-10">
          <h1 class="h5 mb-1">
            <a [routerLink]="[evnt.id, 'addEdit']">{{ evnt.title }}</a>
          </h1>
        </div>
        <div *ngIf="!evnt.ceuFeedbackSubmitted || !evnt.metCEUCriteria || conference.ceuCertificateReleased" class="col-md-2">
          <div class="text-right">
            <div class="position-relative d-inline-block text-right">
              <div class="dropdown">
                <button class="btn btn-xs btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions</button>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                  <a *ngIf="!evnt.ceuFeedbackSubmitted" class="dropdown-item" (click)="addFeedback(evnt)" href="javascript:void(0)">Leave Feedback</a>
                  <a *ngIf="!evnt.metCEUCriteria" class="dropdown-item" (click)="fixCriteria(evnt)" href="javascript:void(0)">Resolve Criteria</a>
                  <a *ngIf="evnt.metCEUCriteria && evnt.ceuFeedbackSubmitted && conference.ceuCertificateReleased" class="dropdown-item" [routerLink]="['../certificates', evnt.id]">View Single Certificate</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <span>
            <a class="mr-2" [routerLink]="['/', evnt.id, 'registration']">{{ evnt.instructor.fullName }}</a>
            <a class="mr-2" *ngFor="let coInstructor of evnt.coInstructors" [routerLink]="['/', evnt.id, 'registration']">{{ coInstructor.fullName }}</a>
          </span>

          <div class="d-md-flex align-items-md-top">
            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0">Date
                <i [pTooltip]="'This is the date you participated in the event.'" class="text-admin-primary fas fa-question-circle"></i>
              </h2>
              <div *ngIf="evnt.ceuParticipationDate">
                <small class="fas fa-calendar-alt text-secondary align-middle mr-1"></small>
                <span class="align-middle">{{ evnt.ceuParticipationDate | date: 'short' }} </span>
              </div>
              <div *ngIf="!evnt.ceuParticipationDate">
                <span class="align-middle">N/A </span>
              </div>
            </div>

            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0">Modality</h2>
              <span class="align-middle">{{ evnt.participationModality | enumValue: ParticipationModality:ParticipationModalityEnum }}</span>
            </div>

            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0">CEUs</h2>
              <span *ngIf="(evnt.ceus | ceuCount) > 0">{{ evnt.ceus | ceuDisplay }}</span>
              <span *ngIf="(evnt.ceus | ceuCount) == 0">0</span>
            </div>

            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0" style="white-space: nowrap">Criteria Met
                <i [pTooltip]="'This column indicates whether or not the criteria was met for CEUs. For In-person attendees, this represents scan data, for live-stream attendees this represents attendance checks.'" class="text-admin-primary fas fa-question-circle"></i>
              </h2>
              <span *ngIf="evnt.metCEUCriteria" class="align-middle text-success"><i (click)="fixCriteria(evnt)" class="fas fa-check-circle"></i></span>
              <span *ngIf="!evnt.metCEUCriteria" class="align-middle text-danger"><i class="fas fa-times-circle"></i> <a class="ml-1" (click)="fixCriteria(evnt)" href="javascript:void(0)">(Fix)</a> </span>
            </div>
            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0" style="white-space: nowrap">Feedback
                <i [pTooltip]="'This column indicates whether or not you\'ve left feedback. You must leave feedback to be eligible for CEUs.'" class="text-admin-primary fas fa-question-circle"></i>
              </h2>
              <span class="align-middle">
                <span *ngIf="evnt.ceuFeedbackSubmitted" class="align-middle text-success mr-1"><i class="fas fa-check-circle"></i> </span>
                <span *ngIf="!evnt.ceuFeedbackSubmitted" class="align-middle text-danger mr-1"><i class="fas fa-times-circle"></i> <a class="ml-1" (click)="addFeedback(evnt)" href="javascript:void(0)">(Fix)</a> </span>
              </span>
            </div>

            <div class="u-ver-divider u-ver-divider--none-md pr-4 mb-3 mb-md-0 mr-4">
              <h2 class="small text-secondary mb-0" style="white-space: nowrap">Required Evals
                <i [pTooltip]="'Certain certification bodies require a separate evaluation. If you are earning these types of CEUs, make sure to complete the eval as well.'" class="text-admin-primary fas fa-question-circle"></i>
              </h2>
              <span class="align-middle">
                  <span *ngFor="let ceu of evnt.ceus">
                    <span style="white-space: nowrap" *ngIf="ceu.certificationBody.feedbackSurveyId">
                  <span class="align-middle  mr-1">
                    <i *ngIf="ceu.evalCompleted" class="fas text-success fa-check-circle"></i>
                    <i *ngIf="!ceu.evalCompleted" class="fas text-danger fa-times-circle"></i>
                    </span>
                  <span *ngIf="ceu.evalCompleted" class="mr-2">{{ ceu.certificationBody.shortName }}</span>
                  <span *ngIf="!ceu.evalCompleted" class="mr-2"><a href="javascript:void(0)" (click)="openEval(ceu.certificationBody.feedbackSurveyId, evnt)">{{ ceu.certificationBody.shortName }}</a></span>
                  </span>
                  </span>

              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
